import * as React from 'react';

import {GlossaryBookmarkIcon} from '../icon/svg/glossary-bookmark-icon';
import {useRefObserver} from '../utils/hooks/use-ref-observer';

import styles from './animating-bookmark.module.css';

export function AnimatingBookmark() {
    const bookmarkRef = React.useRef(null);
    const {isHovered} = useRefObserver(bookmarkRef, ['isHovered']);
    const [bookmarkState, setBookmarkState] = React.useState<'small' | 'expanding' | 'collapsing'>(
        'small'
    );

    React.useEffect(() => {
        if (isHovered) {
            setBookmarkState('expanding');
        } else if (!isHovered && bookmarkState === 'expanding') {
            setBookmarkState('collapsing');
            setTimeout(
                () => {
                    setBookmarkState('small');
                },
                // This is 100ms shorter than the transition duration in the CSS to avoid jumpiness
                400
            );
        }
    }, [isHovered, bookmarkState]);

    let bookmarkStyleName = styles['bookmark--small'];
    if (bookmarkState === 'expanding') {
        bookmarkStyleName = styles['bookmark--expand'];
    } else if (bookmarkState === 'collapsing') {
        bookmarkStyleName = styles['bookmark--collapse'];
    }

    return (
        <div ref={bookmarkRef} className={bookmarkStyleName}>
            <GlossaryBookmarkIcon size={38} />
        </div>
    );
}
